<template>
  <v-dialog
    scrollable
    @input="$emit('update:opened', $event)"
    :value="opened"
    max-width="1000px"
  >
    <v-card>
      <v-card-title>
        <v-container>
          <div class="display-1 font-weight-bold mb-4">
            Vybrat médium
          </div>

          <v-row no-gutters class="mx-n1">
            <v-col cols="6" md="3">
              <v-select
                class="text-overline mx-1"
                outlined
                hide-details
                dense
                :items="mediaTypes"
                v-model="selectedMediaType"
                @change="onMediaTypeChange"
              />
            </v-col>
            <v-col cols="6" md="3">
              <v-select
                class="text-overline mx-1"
                outlined
                hide-details
                dense
                :items="sources"
                v-model="selectedSource"
                @change="onMediaSourceChange"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-container>
          <div class="mediaGrid">
            <v-row class="mx-n1">
              <v-col cols="4" md="2" v-for="item in media" :key="item.id">
                <button
                  @click="$emit('update:selected', item)"
                  :class="[
                    'mediaGrid__item',
                    {
                      'mediaGrid__item--selected':
                        selected && item.id === selected.id,
                    },
                  ]"
                >
                  <div
                    class="mediaGrid__image mb-1 rounded"
                    :style="{ backgroundImage: `url(${item.url128})` }"
                  />
                  <div
                    class="align-center body-1 font-weight-medium"
                    v-text="item.name"
                  />
                  <div class="align-center body-1 mb-2">
                    {{ item.width }}&nbsp;×&nbsp;{{ item.height }}
                  </div>
                </button>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions class="c-dialog__footer">
        <v-container class="d-flex justify-space-between px-6">
          <v-btn text @click="$emit('update:opened', false)">
            Zavřít
          </v-btn>
          <div>
            <v-btn
              color="primary"
              class="c-btn"
              style="margin-right:1em"
              :loading="isSelectingUploadMedia || isUploadingMedia"
              @click="onSelectMedia"
            >
              Nahrát
              <v-icon right dark class="ml-4">
                mdi-plus
              </v-icon>
            </v-btn>
            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept="image/jpeg, image/png"
              @change="onMediaSelected"
            />
            <v-btn
              color="primary"
              class="c-btn"
              @click="
                $emit('confirm')
                $emit('update:opened', false)
              "
            >
              Vybrat
            </v-btn>
          </div>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { call, get } from "vuex-pathify"

export default {
  name: "MediaLibraryDialog",
  props: {
    // media: { type: Array, required: true },
    opened: { type: Boolean, default: false },
    selected: { type: Object, default: null },
  },
  emits: {
    "update:opened": e => typeof e === "boolean",
    "update:selected": null,
    "confirm": null,
  },
  data() {
    return {
      mediaTypes: [
        // { text: "Vše", value: "all" },
        { text: "Obrázky", value: "image" },
        // { text: "Video", value: "video" },
      ],
      sources: [
        // { text: "Adveroo obrázky", value: "app" },
        { text: "Facebook obrázky", value: "fb" },
      ],
      selectedMediaType: "image",
      selectedSource: "fb",
      isSelectingUploadMedia: false,
      isUploadingMedia: false,
    }
  },
  computed: {
    ...get("media", ["images", "videos"]),
    media() {
      // return this.mediaTypes === 'image' ? this.images : this.videos;
      return this.images
    },
  },
  methods: {
    ...call("media", ["loadImages", "uploadImage"]),
    onMediaSourceChange() {
      //
    },
    onMediaTypeChange() {
      //
    },
    onSelectMedia() {
      this.isSelectingUploadMedia = true
      window.addEventListener(
        "focus",
        () => {
          this.isSelectingUploadMedia = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    onMediaSelected(e) {
      this.isUploadingMedia = true
      this.uploadImage(e.target.files[0]).then(() => {
        this.loadImages(true).then(() => {
          this.isUploadingMedia = false
        })
      })
    },
  },
  mounted() {
    this.loadImages()
  },
}
</script>

<style>
/* TODO: use SCSS variables & breakpoints */

.mediaGrid {
  margin: 0 -0.5rem;
}

@media (min-width: 600px) {
  .mediaGrid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 960px) {
  .mediaGrid {
    grid-template-columns: repeat(6, 1fr);
  }
}

.mediaGrid__item {
  border: 1px solid transparent;
  border-radius: 8px;
  transition: border-color 150ms, background-color 150ms;
  width: 100%;
}

.mediaGrid__item:hover {
  background-color: #d9f4ff;
}

.mediaGrid__item--selected {
  border-color: #9de2ff;
  background-color: #d9f4ff;
}

.mediaGrid__image {
  background-color: gray;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  transition: transform 150ms;
  width: 100%;
  padding-top: 100%;
}
</style>
